/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_EmptyInputs */

const cs_integrations_empty = /** @type {(inputs: Integrations_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádná integrační připojení.`)
};

const en_integrations_empty = /** @type {(inputs: Integrations_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No integration connections.`)
};

/**
* | output |
* | --- |
* | "No integration connections." |
*
* @param {Integrations_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_empty = /** @type {((inputs?: Integrations_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_empty(inputs)
	return cs_integrations_empty(inputs)
});